import React from 'react';
import { array, bool, func, shape, string } from 'prop-types';

import MenuItem from '@material-ui/core/MenuItem';

import CheckboxGroup from '../FormFields/CheckboxGroup';
import RuleProcessing from './RuleProcessing';
import Select from '../FormFields/Select';
import { TabContent } from '../TabPanel';
import TextArea from '../FormFields/TextArea';

import defaultClasses from './RulePropertiesFieldset.module.css';

const ISSUE_TYPES = [
    'Comfort',
    'Controls',
    'Energy',
    'Maintenance',
    'Mechanical',
    'Health and Safety'
];

const RulePropertiesFieldset = ({
    disabled,
    errors,
    onBlur,
    onChange,
    onPatch,
    touched,
    values
}) => (
    <TabContent>
        <div className={defaultClasses.fieldset}>
            <Select
                errors={errors.priority}
                disabled={disabled}
                label="Rule Priority"
                onBlur={onBlur}
                onChange={onChange}
                name="priority"
                required
                touched={touched.priority}
                value={values.priority}
            >
                <MenuItem value={2}>High</MenuItem>
                <MenuItem value={1}>Medium</MenuItem>
                <MenuItem value={0}>Low</MenuItem>
            </Select>

            <TextArea
                disabled={disabled}
                label="Description"
                name="description"
                onBlur={onBlur}
                onChange={onChange}
                placeholder="Enter a description of this custom rule"
                value={values.description || ''}
            />

            <TextArea
                disabled={disabled}
                label="System Effect"
                name="systemEffect"
                onBlur={onBlur}
                onChange={onChange}
                placeholder="Enter the system effect of this custom rule"
                value={values.systemEffect || ''}
            />

            <TextArea
                disabled={disabled}
                label="Recommendation"
                name="recommendation"
                onBlur={onBlur}
                onChange={onChange}
                placeholder="Enter a recommendation for this custom rule"
                value={values.recommendation || ''}
            />

            <CheckboxGroup
                disabled={disabled}
                label="Issue Type"
                name="issueTypes"
                onBlur={onBlur}
                onChange={onChange}
                options={ISSUE_TYPES}
                value={values.issueTypes ? values.issueTypes : []}
            />

            <RuleProcessing
                disabled={disabled}
                errors={errors}
                onBlur={onBlur}
                onChange={onChange}
                onPatch={onPatch}
                touched={touched}
                values={values}
            />
        </div>
    </TabContent>
);

RulePropertiesFieldset.defaultProps = {
    disabled: false,
    errors:   {},
    onChange: () => {},
    onPatch:  () => {},
    touched:  {},
    values:   {}
};

RulePropertiesFieldset.propTypes = {
    disabled: bool,
    errors:   shape({
        priority: string
    }),
    touched: shape({
        priority: bool
    }),
    onChange: func,
    onPatch:  func,
    values:   shape({
        issueTypes: array
    })
};

export default RulePropertiesFieldset;
